import React, {useEffect, useState} from 'react';
import Button from '../../../../../../../../../../../../../../components/button';
import Icon from '../../../../../../../../../../../../../../components/icon';
import {useDispatch, useSelector} from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
	getChangedStatus,
	isHiddenFieldsChanging as setIsHiddenFieldsChanging,
	hiddenFieldsUpdate as setHiddenFieldsUpdate,
	selectedCollaborator as setSelectedCollaborator, showHiddenFields, updateCollaborators as setUpdateCollaborators
} from '../../../../../../../../../../../../../../../actions/sharingDetailsActions';
import './index.css';

function HiddenFieldsList (props) {

	const { t } = useTranslation();

	const updateCollaborators = useSelector(state => state.sharingDetailsReducer.updateCollaborators);
	const changedStatus = useSelector(state => state.sharingDetailsReducer.getChangedStatus);
	const isHiddenFieldsChanging = useSelector(state => state.sharingDetailsReducer.isHiddenFieldsChanging);
	const hiddenFieldsUpdate = useSelector(state => state.sharingDetailsReducer.hiddenFieldsUpdate);
	const [emailHomeSubField, setEmailHomeSubField] = useState(hiddenFieldsUpdate?.email?.home || false);
	const [emailOtherSubField, setEmailOtherSubField] = useState(hiddenFieldsUpdate?.email?.other || false);
	const [emailWorkSubField, setEmailWorkSubField] = useState(hiddenFieldsUpdate?.email?.work || false);
	const [phoneHomeSubField, setPhoneHomeSubField] = useState(hiddenFieldsUpdate?.phone?.home || false);
	const [phoneMainSubField, setPhoneMainSubField] = useState(hiddenFieldsUpdate?.phone?.main || false);
	const [phoneMobileSubField, setPhoneMobileSubField] = useState(hiddenFieldsUpdate?.phone?.mobile || false);
	const [phoneOtherSubField, setPhoneOtherSubField] = useState(hiddenFieldsUpdate?.phone?.other || false);
	const [phoneWorkSubField, setPhoneWorkSubField] = useState(hiddenFieldsUpdate?.phone?.work || false);
	const [addressHomeSubField, setAddressHomeSubField] = useState(hiddenFieldsUpdate?.address?.home || false);
	const [addressOtherSubField, setAddressOtherSubField] = useState(hiddenFieldsUpdate?.address?.other || false);
	const [addressWorkSubField, setAddressWorkSubField] = useState(hiddenFieldsUpdate?.address?.work || false);
	const [showSubFields, setShowSubFields] = useState("");

	const togglePhoneHome = (boolean) => {
		setPhoneHomeSubField(boolean);
		changeHiddenFieldStatus("phone", {
			home: boolean,
			main: phoneMainSubField,
			mobile: phoneMobileSubField,
			other: phoneOtherSubField,
			work: phoneWorkSubField
		})
	};

	const togglePhoneMain = (boolean) => {
		setPhoneMainSubField(boolean);
		changeHiddenFieldStatus("phone", {
			home: phoneHomeSubField,
			main: boolean,
			mobile: phoneMobileSubField,
			other: phoneOtherSubField,
			work: phoneWorkSubField
		})
	};

	const togglePhoneMobile = (boolean) => {
		setPhoneMobileSubField(boolean);
		changeHiddenFieldStatus("phone", {
			home: phoneHomeSubField,
			main: phoneMainSubField,
			mobile: boolean,
			other: phoneOtherSubField,
			work: phoneWorkSubField
		})
	};

	const togglePhoneOther = (boolean) => {
		setPhoneOtherSubField(boolean);
		changeHiddenFieldStatus("phone", {
			home: phoneHomeSubField,
			main: phoneMainSubField,
			mobile: phoneMobileSubField,
			other: boolean,
			work: phoneWorkSubField
		})
	};

	const togglePhoneWork = (boolean) => {
		setPhoneWorkSubField(boolean);
		changeHiddenFieldStatus("phone", {
			home: phoneHomeSubField,
			main: phoneMainSubField,
			mobile: phoneMobileSubField,
			other: phoneOtherSubField,
			work: boolean
		})
	};

	const toggleEmailHome = (boolean) => {
		setEmailHomeSubField(boolean);
		changeHiddenFieldStatus("email", {
			home: boolean,
			other: emailOtherSubField,
			work: emailWorkSubField
		})
	};

	const toggleEmailOther = (boolean) => {
		setEmailOtherSubField(boolean);
		changeHiddenFieldStatus("email", {
			home: emailHomeSubField,
			other: boolean,
			work: emailWorkSubField
		})
	};

	const toggleEmailWork = (boolean) => {
		setEmailWorkSubField(boolean);
		changeHiddenFieldStatus("email", {
			home: emailHomeSubField,
			other: emailOtherSubField,
			work: boolean
		})
	};

	const toggleAddressHome = (boolean) => {
		setAddressHomeSubField(boolean);
		changeHiddenFieldStatus("address", {
			home: boolean,
			other: addressOtherSubField,
			work: addressWorkSubField
		})
	};

	const toggleAddressOther = (boolean) => {
		setAddressOtherSubField(boolean);
		changeHiddenFieldStatus("address", {
			home: addressHomeSubField,
			other: boolean,
			work: addressWorkSubField
		})
	};

	const toggleAddressWork = (boolean) => {
		setAddressWorkSubField(boolean);
		changeHiddenFieldStatus("address", {
			home: addressHomeSubField,
			other: addressOtherSubField,
			work: boolean
		})
	};

	const dispatch = useDispatch();

	const { hiddenFields } = props;

	useEffect(() => {

		if(JSON.stringify(hiddenFieldsUpdate) !== JSON.stringify(hiddenFields)){
			dispatch(setIsHiddenFieldsChanging(true));
		} else {
			dispatch(setIsHiddenFieldsChanging(false));
		}

	}, [dispatch, hiddenFields, hiddenFieldsUpdate]);

	const changeHiddenFieldStatus = (field, value) => {

		if(hiddenFields[field]){

			// If the targeted hidden fields are initially activated

			if(field === 'email'){

				if(value?.home === false && value?.other === false && value?.work === false){

					// All subfields are set to false because empty object is not accepted by the API
					dispatch(setHiddenFieldsUpdate({
						...hiddenFieldsUpdate,
						[field]: value
					}));

					// State manually set to false because the object is just emptied.
					setEmailHomeSubField(false);
					setEmailWorkSubField(false);
					setEmailOtherSubField(false);

				} else if (value?.home === true && value?.other === true && value?.work === true) {

					dispatch(setHiddenFieldsUpdate({
						...hiddenFieldsUpdate,
						[field]: value
					}));

					setEmailHomeSubField(true);
					setEmailWorkSubField(true);
					setEmailOtherSubField(true);

				} else {

					let saveFilteredSubCurrentFields = value;

					Object.keys(value).forEach( item => {

						if(value[item] === false){
							const {[item]: _, ...filteredSubCurrentFields} = saveFilteredSubCurrentFields;

							saveFilteredSubCurrentFields = filteredSubCurrentFields

							item === "home" && setEmailHomeSubField(false);
							item === "other" && setEmailOtherSubField(false);
							item === "work" && setEmailWorkSubField(false);
						}

					});

					if(Object.keys(saveFilteredSubCurrentFields).length > 0){
						dispatch(setHiddenFieldsUpdate({
							...hiddenFieldsUpdate,
							[field]: saveFilteredSubCurrentFields
						}));
					} else {
						const {[field]: _, ...filteredCurrentFields} = hiddenFieldsUpdate;
						dispatch(setHiddenFieldsUpdate(filteredCurrentFields));
					}

				}

			} else if (field === 'phone') {

				if (
					value?.home === false
					&& value?.main === false
					&& value?.mobile === false
					&& value?.other === false
					&& value?.work === false
				) {

					// All subfields are set to false because empty object is not accepted by the API
					dispatch(setHiddenFieldsUpdate({
						...hiddenFieldsUpdate,
						[field]: value
					}));

					// State manually set to false because the object is just emptied.
					setPhoneHomeSubField(false);
					setPhoneMainSubField(false);
					setPhoneMobileSubField(false);
					setPhoneOtherSubField(false);
					setPhoneWorkSubField(false);

				} else if (
					value?.home === true
					&& value?.main === true
					&& value?.mobile === true
					&& value?.other === true
					&& value?.work === true
				) {

					dispatch(setHiddenFieldsUpdate({
						...hiddenFieldsUpdate,
						[field]: value
					}));

					setPhoneHomeSubField(true);
					setPhoneMainSubField(true);
					setPhoneMobileSubField(true);
					setPhoneOtherSubField(true);
					setPhoneWorkSubField(true);

				} else {

					let saveFilteredSubCurrentFields = value;

					Object.keys(value).forEach( item => {

						if(value[item] === false){
							const {[item]: _, ...filteredSubCurrentFields} = saveFilteredSubCurrentFields;

							saveFilteredSubCurrentFields = filteredSubCurrentFields

							item === "home" && setPhoneHomeSubField(false);
							item === "main" && setPhoneMainSubField(false);
							item === "mobile" && setPhoneMobileSubField(false);
							item === "other" && setPhoneOtherSubField(false);
							item === "work" && setPhoneWorkSubField(false);
						}

					});

					if(Object.keys(saveFilteredSubCurrentFields).length > 0){
						dispatch(setHiddenFieldsUpdate({
							...hiddenFieldsUpdate,
							[field]: saveFilteredSubCurrentFields
						}));
					} else {
						const {[field]: _, ...filteredCurrentFields} = hiddenFieldsUpdate;
						dispatch(setHiddenFieldsUpdate(filteredCurrentFields));
					}

				}

			} else if (field === 'address') {

				if(value?.home === false && value?.other === false && value?.work === false){

					// All subfields are set to false because empty object is not accepted by the API
					dispatch(setHiddenFieldsUpdate({
						...hiddenFieldsUpdate,
						[field]: value
					}));

					// State manually set to false because the object is just emptied.
					setAddressHomeSubField(false);
					setAddressWorkSubField(false);
					setAddressOtherSubField(false);

				} else if (value?.home === true && value?.other === true && value?.work === true) {

					dispatch(setHiddenFieldsUpdate({
						...hiddenFieldsUpdate,
						[field]: value
					}));

					setAddressHomeSubField(true);
					setAddressWorkSubField(true);
					setAddressOtherSubField(true);

				} else {

					let saveFilteredSubCurrentFields = value;

					Object.keys(value).forEach( item => {

						if(value[item] === false){
							const {[item]: _, ...filteredSubCurrentFields} = saveFilteredSubCurrentFields;

							saveFilteredSubCurrentFields = filteredSubCurrentFields

							item === "home" && setAddressHomeSubField(false);
							item === "other" && setAddressOtherSubField(false);
							item === "work" && setAddressWorkSubField(false);
						}

					});

					if(Object.keys(saveFilteredSubCurrentFields).length > 0){
						dispatch(setHiddenFieldsUpdate({
							...hiddenFieldsUpdate,
							[field]: saveFilteredSubCurrentFields
						}));
					} else {
						const {[field]: _, ...filteredCurrentFields} = hiddenFieldsUpdate;
						dispatch(setHiddenFieldsUpdate(filteredCurrentFields));
					}

				}

			} else {

				dispatch(setHiddenFieldsUpdate({
					...hiddenFieldsUpdate,
					[field]: value
				}));

			}

		} else {

			// If the targeted hidden field is not activated and not in the API response

			if(field === 'email'){

				if(value?.home === false && value?.other === false && value?.work === false){
					const {[field]: _, ...filteredCurrentFields} = hiddenFieldsUpdate;
					dispatch(setHiddenFieldsUpdate(filteredCurrentFields));

					// State manually set to false because the object is just emptied.
					setEmailHomeSubField(false);
					setEmailWorkSubField(false);
					setEmailOtherSubField(false);
				} else if (value?.home === true && value?.other === true && value?.work === true) {
					dispatch(setHiddenFieldsUpdate({
						...hiddenFieldsUpdate,
						[field]: value
					}));

					setEmailHomeSubField(true);
					setEmailWorkSubField(true);
					setEmailOtherSubField(true);
				} else {
					if(value){
						dispatch(setHiddenFieldsUpdate({
							...hiddenFieldsUpdate,
							[field]: value
						}));
					} else {
						const {[field]: _, ...filteredCurrentFields} = hiddenFieldsUpdate;
						dispatch(setHiddenFieldsUpdate(filteredCurrentFields));
					}
				}

			} else if (field === 'phone') {

				if(
					value?.home === false
					&& value?.main === false
					&& value?.mobile === false
					&& value?.other === false
					&& value?.work === false
				){
					const {[field]: _, ...filteredCurrentFields} = hiddenFieldsUpdate;
					dispatch(setHiddenFieldsUpdate(filteredCurrentFields));

					// State manually set to false because the object is just emptied.
					setPhoneHomeSubField(false);
					setPhoneMainSubField(false);
					setPhoneMobileSubField(false);
					setPhoneOtherSubField(false);
					setPhoneWorkSubField(false);
				} else if (
					value?.home === true
					&& value?.main === true
					&& value?.mobile === true
					&& value?.other === true
					&& value?.work === true
				) {
					dispatch(setHiddenFieldsUpdate({
						...hiddenFieldsUpdate,
						[field]: value
					}));

					setPhoneHomeSubField(true);
					setPhoneMainSubField(true);
					setPhoneMobileSubField(true);
					setPhoneOtherSubField(true);
					setPhoneWorkSubField(true);
				} else {
					if(value){
						dispatch(setHiddenFieldsUpdate({
							...hiddenFieldsUpdate,
							[field]: value
						}));
					} else {
						const {[field]: _, ...filteredCurrentFields} = hiddenFieldsUpdate;
						dispatch(setHiddenFieldsUpdate(filteredCurrentFields));
					}
				}

			} else if (field === 'address') {

				if(value?.home === false && value?.other === false && value?.work === false){
					const {[field]: _, ...filteredCurrentFields} = hiddenFieldsUpdate;
					dispatch(setHiddenFieldsUpdate(filteredCurrentFields));

					// State manually set to false because the object is just emptied.
					setAddressHomeSubField(false);
					setAddressWorkSubField(false);
					setAddressOtherSubField(false);
				} else if (value?.home === true && value?.other === true && value?.work === true) {
					dispatch(setHiddenFieldsUpdate({
						...hiddenFieldsUpdate,
						[field]: value
					}));

					setAddressHomeSubField(true);
					setAddressWorkSubField(true);
					setAddressOtherSubField(true);

				} else {
					if(value){
						dispatch(setHiddenFieldsUpdate({
							...hiddenFieldsUpdate,
							[field]: value
						}));
					} else {
						const {[field]: _, ...filteredCurrentFields} = hiddenFieldsUpdate;
						dispatch(setHiddenFieldsUpdate(filteredCurrentFields));
					}
				}

			} else {

				if(value){
					dispatch(setHiddenFieldsUpdate({
						...hiddenFieldsUpdate,
						[field]: value
					}));
				} else {
					const {[field]: _, ...filteredCurrentFields} = hiddenFieldsUpdate;
					dispatch(setHiddenFieldsUpdate(filteredCurrentFields));
				}

			}

		}

	};

	const closeHiddenFields = () => {
		dispatch(setSelectedCollaborator(null));
		dispatch(showHiddenFields(false));

		if(updateCollaborators.length > 0){
			dispatch(setUpdateCollaborators([]));
		}

		if(changedStatus){
			dispatch(getChangedStatus(false));
		}

		if (isHiddenFieldsChanging){
			dispatch(setIsHiddenFieldsChanging(false));
		}

		if(Object.entries(hiddenFieldsUpdate).length > 0){
			dispatch(setHiddenFieldsUpdate({}));
		}
	};

	return (
		<div className="list-of-fields">
			<div className="list-of-fields__head">
				{t('fieldsList')}
			</div>
			<div className="list-of-fields__body">
				<div className="col-6">
					<div className="list-of-fields__body__field border-bottom">
						<h2>Fields</h2>{showSubFields}
					</div>
					<div className="list-of-fields__body__fields">
						<ul>
							<li>
								<span className="field-name">{t('fieldOrganization')}</span>
								{
									hiddenFieldsUpdate?.organization
										?
										<Button onClick={() => changeHiddenFieldStatus("organization", false)} className="btn-link">
											<Icon color="#ed1c24" name={'eye-slash'}/>
										</Button>
										:
										<Button onClick={() => changeHiddenFieldStatus("organization", true)} className="btn-link">
											<Icon color="#007bff" name={'eye'}/>
										</Button>
								}
							</li>
							<li>
								<span className="field-name">{t('fieldPhone')}</span>
								{
									showSubFields === "phone"
										?
										<Button onClick={() => setShowSubFields("")} className="btn-link">
											<Icon color="#575757" width="1em" name={'angle-double-left'}/>
										</Button>
										:
										<Button onClick={() => setShowSubFields("phone")} className="btn-link">
											<Icon color="#22b14c" width="1em" name={'angle-double-right'}/>
										</Button>
								}
							</li>
							<li>
								<span className="field-name">{t('fieldEmail')}</span>
								{
									showSubFields === "email"
										?
										<Button onClick={() => setShowSubFields("")} className="btn-link">
											<Icon color="#575757" width="1em" name={'angle-double-left'}/>
										</Button>
										:
										<Button onClick={() => setShowSubFields("email")} className="btn-link">
											<Icon color="#22b14c" width="1em" name={'angle-double-right'}/>
										</Button>
								}
							</li>
							<li>
								<span className="field-name">{t('fieldPostalAddress')}</span>
								{
									showSubFields === "address"
										?
										<Button onClick={() => setShowSubFields("")} className="btn-link">
											<Icon color="#575757" width="1em" name={'angle-double-left'}/>
										</Button>
										:
										<Button onClick={() => setShowSubFields("address")} className="btn-link">
											<Icon color="#22b14c" width="1em" name={'angle-double-right'}/>
										</Button>
								}
							</li>
							<li>
								<span className="field-name">{t('fieldBirthday')}</span>
								{
									hiddenFieldsUpdate?.birthday
										?
										<Button onClick={() => changeHiddenFieldStatus("birthday", false)} className="btn-link">
											<Icon color="#ed1c24" name={'eye-slash'}/>
										</Button>
										:
										<Button onClick={() => changeHiddenFieldStatus("birthday", true)} className="btn-link">
											<Icon color="#007bff" name={'eye'}/>
										</Button>
								}
							</li>
							<li>
								<span className="field-name">{t('fieldDescription')}</span>
								{
									hiddenFieldsUpdate?.notes
										?
										<Button onClick={() => changeHiddenFieldStatus("notes", false)} className="btn-link">
											<Icon color="#ed1c24" name={'eye-slash'}/>
										</Button>
										:
										<Button onClick={() => changeHiddenFieldStatus("notes", true)} className="btn-link">
											<Icon color="#007bff" name={'eye'}/>
										</Button>
								}
							</li>
							<li>
								<span className="field-name">{t('fieldComments')}</span>
								{
									hiddenFieldsUpdate?.comment
										?
										<Button onClick={() => changeHiddenFieldStatus("comment", false)} className="btn-link">
											<Icon color="#ed1c24" name={'eye-slash'}/>
										</Button>
										:
										<Button onClick={() => changeHiddenFieldStatus("comment", true)} className="btn-link">
											<Icon color="#007bff" name={'eye'}/>
										</Button>
								}
							</li>
						</ul>
					</div>
				</div>
				{
					showSubFields && showSubFields === "phone" && <div className="col-6">
						<div className="list-of-fields__body__field border-bottom">
							<h2>Labels</h2>
						</div>
						<div className="list-of-fields__body__subfields">
							<div className="list-of-fields__body__subfields__title">
								Phone Fields
							</div>
							<div className="list-of-fields__body__subfields__content">
								<ul>
									<li>
										<span className="subfield-name">Home</span>
										{
											hiddenFieldsUpdate?.phone?.home || phoneHomeSubField
												?
												<Button onClick={() => togglePhoneHome(false)} className="btn-link">
													<Icon color="#ed1c24" name={'eye-slash'}/>
												</Button>
												:
												<Button onClick={() => togglePhoneHome(true)} className="btn-link">
													<Icon color="#007bff" name={'eye'}/>
												</Button>
										}
									</li>
									<li>
										<span className="subfield-name">Main</span>
										{
											hiddenFieldsUpdate?.phone?.main || phoneMainSubField
												?
												<Button onClick={() => togglePhoneMain(false)} className="btn-link">
													<Icon color="#ed1c24" name={'eye-slash'}/>
												</Button>
												:
												<Button onClick={() => togglePhoneMain(true)} className="btn-link">
													<Icon color="#007bff" name={'eye'}/>
												</Button>
										}
									</li>
									<li>
										<span className="subfield-name">Mobile</span>
										{
											hiddenFieldsUpdate?.phone?.mobile || phoneMobileSubField
												?
												<Button onClick={() => togglePhoneMobile(false)} className="btn-link">
													<Icon color="#ed1c24" name={'eye-slash'}/>
												</Button>
												:
												<Button onClick={() => togglePhoneMobile(true)} className="btn-link">
													<Icon color="#007bff" name={'eye'}/>
												</Button>
										}
									</li>
									<li>
										<span className="subfield-name">Other</span>
										{
											hiddenFieldsUpdate?.phone?.other || phoneOtherSubField
												?
												<Button onClick={() => togglePhoneOther(false)} className="btn-link">
													<Icon color="#ed1c24" name={'eye-slash'}/>
												</Button>
												:
												<Button onClick={() => togglePhoneOther(true)} className="btn-link">
													<Icon color="#007bff" name={'eye'}/>
												</Button>
										}
									</li>
									<li>
										<span className="subfield-name">Work</span>
										{
											hiddenFieldsUpdate?.phone?.work || phoneWorkSubField
												?
												<Button onClick={() => togglePhoneWork(false)} className="btn-link">
													<Icon color="#ed1c24" name={'eye-slash'}/>
												</Button>
												:
												<Button onClick={() => togglePhoneWork(true)} className="btn-link">
													<Icon color="#007bff" name={'eye'}/>
												</Button>
										}
									</li>
								</ul>
							</div>
						</div>
					</div>
				}
				{
					showSubFields && showSubFields === "email" && <div className="col-6">
						<div className="list-of-fields__body__field border-bottom">
							<h2>Labels</h2>
						</div>
						<div className="list-of-fields__body__subfields">
							<div className="list-of-fields__body__subfields__title">
								Email Fields
							</div>
							<div className="list-of-fields__body__subfields__content">
								<ul>
								<li>
									<span className="subfield-name">Home</span>
									{
										hiddenFieldsUpdate?.email?.home || emailHomeSubField
											?
											<Button onClick={() => toggleEmailHome(false)} className="btn-link">
												<Icon color="#ed1c24" name={'eye-slash'}/>
											</Button>
											:
											<Button onClick={() => toggleEmailHome(true)} className="btn-link">
												<Icon color="#007bff" name={'eye'}/>
											</Button>
									}
								</li>
								<li>
									<span className="subfield-name">Other</span>
									{
										hiddenFieldsUpdate?.email?.other || emailOtherSubField
											?
											<Button onClick={() => toggleEmailOther(false)} className="btn-link">
												<Icon color="#ed1c24" name={'eye-slash'}/>
											</Button>
											:
											<Button onClick={() => toggleEmailOther(true)} className="btn-link">
												<Icon color="#007bff" name={'eye'}/>
											</Button>
									}
								</li>
								<li>
									<span className="subfield-name">Work</span>
									{
										hiddenFieldsUpdate?.email?.work || emailWorkSubField
											?
											<Button onClick={() => toggleEmailWork(false)} className="btn-link">
												<Icon color="#ed1c24" name={'eye-slash'}/>
											</Button>
											:
											<Button onClick={() => toggleEmailWork(true)} className="btn-link">
												<Icon color="#007bff" name={'eye'}/>
											</Button>
									}
								</li>
								</ul>
							</div>
						</div>
					</div>
				}
				{
					showSubFields && showSubFields === "address" && <div className="col-6">
						<div className="list-of-fields__body__field border-bottom">
							<h2>Labels</h2>
						</div>
						<div className="list-of-fields__body__subfields">
							<div className="list-of-fields__body__subfields__title">
								Address Fields
							</div>
							<div className="list-of-fields__body__subfields__content">
								<ul>
									<li>
										<span className="subfield-name">Home</span>
										{
											hiddenFieldsUpdate?.address?.home || addressHomeSubField
												?
												<Button onClick={() => toggleAddressHome(false)} className="btn-link">
													<Icon color="#ed1c24" name={'eye-slash'}/>
												</Button>
												:
												<Button onClick={() => toggleAddressHome(true)} className="btn-link">
													<Icon color="#007bff" name={'eye'}/>
												</Button>
										}
									</li>
									<li>
										<span className="subfield-name">Other</span>
										{
											hiddenFieldsUpdate?.address?.other || addressOtherSubField
												?
												<Button onClick={() => toggleAddressOther(false)} className="btn-link">
													<Icon color="#ed1c24" name={'eye-slash'}/>
												</Button>
												:
												<Button onClick={() => toggleAddressOther(true)} className="btn-link">
													<Icon color="#007bff" name={'eye'}/>
												</Button>
										}
									</li>
									<li>
										<span className="subfield-name">Work</span>
										{
											hiddenFieldsUpdate?.address?.work || addressWorkSubField
												?
												<Button onClick={() => toggleAddressWork(false)} className="btn-link">
													<Icon color="#ed1c24" name={'eye-slash'}/>
												</Button>
												:
												<Button onClick={() => toggleAddressWork(true)} className="btn-link">
													<Icon color="#007bff" name={'eye'}/>
												</Button>
										}
									</li>
								</ul>
							</div>
						</div>
					</div>
				}
			</div>

			<Button onClick={closeHiddenFields} className="btn-link m-0 p-0">
				&laquo; {t('getBackText')}
			</Button>
		</div>
	)
}

export default HiddenFieldsList;
